"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatBox = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../../atoms/Text");
function StatBox({ title, value, description, testId }) {
    return (react_1.default.createElement("div", { className: "bg-gray-700 border border-borderColor rounded-default py-4 px-5", "data-testid": testId },
        react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.BODY_S }, title),
        react_1.default.createElement("div", { className: "flex items-start mt-2" },
            react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.PAGE_HEADING, className: "mr-2 text-ellipsis overflow-hidden whitespace-nowrap text-blue-200", testId: `${testId}:value` }, value),
            react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.BODY_MICO, subdued: true, testId: `${testId}:description` }, description))));
}
exports.StatBox = StatBox;
//# sourceMappingURL=StatBox.js.map